import { Blitter } from './blitter.js';

/**
 * Copy blitter
 * @public
 */ class CopyBlitter extends Blitter {
    /**
   * {@inheritDoc Blitter.filter}
   * @override
   */ filter(scope, type, srcTex, srcUV, srcLayer, sampleType) {
        return this.readTexel(scope, type, srcTex, srcUV, srcLayer, sampleType);
    }
    /**
   * {@inheritDoc Blitter.calcHash}
   * @override
   */ calcHash() {
        return '';
    }
}

export { CopyBlitter };
//# sourceMappingURL=copy.js.map
